export enum AnalyticsDashboardType {
  Engagement = "engagementanalytics",
  Prospects = "prospectanalytics",
  AmboStudent = "studentamboanalytics",
  AmboStaff = "staffamboanalytics",
  ProspectInsights = "prospectinsightsanalytics",
}

export enum CustomerTier {
  PremiumPlusCustomer = "premiumplus",
  LiteAndProCustomer = "liteandpro",
}

export const LOGO_SERVICE_TRACKING = 'logotracking';
